function headerSticky() {
    if (headerEl) {
        let top = 130;
        if (window.innerWidth < 1200) {
            top = 90;
        }
        if (window.scrollY >= top) {
            headerEl.classList.add('sticky');
        } else {
            headerEl.classList.remove('sticky');
        }
    }
}

function nav() {
    let navEl = document.getElementById('jsNav'),
        navBtnEl = document.getElementById('jsNavBtn'),
        navBtnCloseEl = document.getElementById('jsNavBtnClose');
    if (navBtnEl) {
        navBtnEl.addEventListener('click', function() {
            if (navEl.classList.contains('show')) {
                navEl.classList.remove('show');
                navBtnEl.classList.remove('expand');
            } else {
                navEl.classList.add('show');
                navBtnEl.classList.add('expand');
            }
        });
    }
    if (navBtnCloseEl) {
        navBtnCloseEl.addEventListener('click', function() {
            navEl.classList.remove('show');
        });
    }
}

function expandParent(className) {
    let expandEls = document.querySelectorAll(className);
    if (expandEls.length > 0) {
        expandEls.forEach(expandEl => {
            expandEl.addEventListener('click', function(event) {
                if (expandEl.parentElement.classList.contains('expand')) {
                    expandEl.parentElement.classList.remove('expand');
                } else {
                    expandEl.parentElement.classList.add('expand');
                }
                event.preventDefault();
            });
        });
    }
}

let headerEl = document.getElementById('jsHeader'),
    timerScrollHeader;
window.addEventListener('load', function() {
    headerEl = document.getElementById('jsHeader');
    headerSticky();
    nav();
    expandParent('.jsExpand');
});

function timeoutScrollHeader() {}
window.addEventListener('scroll', function() {
    clearTimeout(timerScrollHeader);
    timerScrollHeader = setTimeout(timeoutScrollHeader, 100);
    headerSticky();
});